import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-contact-merchant',
  templateUrl: './contact-merchant.component.html',
  styleUrls: ['./contact-merchant.component.scss'],
})
export class ContactMerchantComponent {
  @Input() brandColor!: string;
  @Input() textColor!: string;
  @Input() merchantPhone?: string;
  @Input() merchantEmail?: string;
  @Input() merchantName?: string;
  @Input() orderStatus?: string;
  @Input() contained?: boolean;
}
